import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const openAppRoutes: CustomRouteRecordRaw = {
  path: 'open-app',
  name: 'openApp',
  component: () => import('@/views/open-app/app-list.vue'),
  meta: {
    title: '开放应用管理',
    iconfont: 'icon-apps-line',
    requiredPermission: 'open-app'
  },
}
